import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { initFacebookPixel } from './lib/fpixel';
initFacebookPixel();
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-11" />);
}